@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

@medium-width-modal: 780px;

.drawer-body {
  overflow-y: auto;
  flex: 1;
  background-color: var(--grey-100);
  padding: @space-16;
}

.flow-container {
  align-items: center;
  width: 100%;
}

.flow-step-box {
  background-color: var(--white);
  border-radius: 8px;
  border: 1px solid var(--grey-400);
  padding: @space-16 @space-24;
  width: 100%;
  max-width: 650px;
  box-sizing: border-box;
  align-items: center;
}

.flow-step-check {
  color: var(--green-500);
  flex-shrink: 0;
  margin-left: auto;
}

.flow-connector {
  align-items: center;
}

.flow-connector-line {
  width: 1px;
  height: 50px;
  background-color: var(--grey-300);
}

.form-card {
  background-color: var(--white);
  border-radius: 8px;
  border: 2px solid var(--blue-500);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 900px;
  box-sizing: border-box;
}

.drawer-footer {
  justify-content: space-between;
  padding: @space-16 @space-24;
  border-top: 1px solid var(--grey-200);
}

.rule-meta-row {
  display: flex;
  flex-direction: column;
}

.dropdown-toggler {
  width: 100%;
  background-color: @settings-page--automation-rules-dropdown--background-color;
  height: 32px;
  border-radius: 4px;
  border: 1px solid @settings-page--automation-rules-dropdown--border-color;
  &:active,
  &:hover {
    background-color: @settings-page--automation-rules-dropdown--hover--background-color;
    border-top: 1px solid @settings-page--automation-rules-dropdown--hover--border-color;
  }
}

.dropdown-item {
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    margin-right: 10px;
  }
}

.existing-filters {
  min-width: 200px;
  font-size: 14px;
  width: 420px;
}

.name-and-status {
  display: flex;
  padding: 10px 20px;
}

.rule-name,
.rule-active {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  width: 50%;
  font-weight: 500;
  > div {
    padding-bottom: 5px;
    height: 100%;
  }
}

.rule-active {
  padding-left: 10px;
}

.add-action-wrap {
  font-size: 14px;
  margin: 0 0 20px 20px;
}

.create-icon {
  width: 10px;
  height: 10px;
  margin-right: 5px;
}

.delete-rule {
  color: @settings-page--automation-rules-delete-rule--text-color;
}

.cancel-button {
  margin-right: 10px;
}

.form-error {
  margin-bottom: 20px;
}

.loading-icon {
  height: 64px;
  margin: 200px auto;
}

.rule-type-wrap {
  padding: 10px 20px;
}

.rule-type-label {
  align-items: center;
}

.rule-badge {
  min-width: 40px;
}

.rule-type-dropdown {
  width: 380px;
}

.rule-type-header {
  font-weight: 500;
  font-size: 14px;
}

.template-icon {
  color: var(--blue-1D5AD8);
  margin-top: 34px;
  width: 18px;
  height: 18px;
}

.disabled {
  color: @settings-page--automation-rules-disabled--text-color;
}

.button-group {
  padding: 8px 0;
}

.ai-banner-content {
  align-items: center;
  justify-content: center;
}

// Make the text bold and black
.ai-banner-text {
  color: var(--grey--900);
  font-weight: 600;
  margin: 0;
}

.ai-banner-icon {
  color: var(--orange-FFA500);
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

// Custom AI generated banner with colorful gradient border
.ai-generated-banner {
  border: 2px solid transparent;
  border-radius: 8px;
  background:
    linear-gradient(var(--white), var(--white)) padding-box,
    linear-gradient(90deg, var(--blue-93CCFD) 0%, var(--purple-B085FF) 50%, var(--red-F1C1C1) 100%) border-box;
  margin: 20px 20px 16px;
  padding: 12px 16px;
}
